;
define("facets_item_list_show_selector.tpl", function(){});

